import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid } from "@mui/material";
import {
  deleteFaq,
  getFaq,
  patchUpdateFaq,
  postAddFaq,
} from "redux/actions/UserFAQ";
import CommonBreadCrumb from "components/commonBreadCrumb/CommonBreadCrumb";
import FaqTab from "./FaqTab";
import CommonDialog from "components/commonDialog/CommonDialog";
import { addFaqData } from "./FaqData";

function FAQView() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("Create");
  const [value, setValue] = useState("Customer");

  const { state } = useLocation();

  const { page, parentId } = state;
  const [defaultValue, setDefaultValue] = useState({});
  const [faqId, setFaqId] = useState("");
  const FaqData = useSelector((state) => state.userFaq?.userFaq?.data);
  const faqLoader = useSelector((state) => state?.userFaq?.loading);

  const breadcrumbPaths = [
    { name: "Configuration", url: "", className: "colorGrey fontSemi" },
    { name: "FAQ", url: "/faq", className: "colorGrey fontSemi" },
    { name: `${page}`, url: "/", className: "colorBlue" },
  ];
  const filterData = {
    id: parentId,
    role: value,
  };
  useEffect(() => {
    dispatch(getFaq(filterData));
  }, []);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === "Customer") {
      const filterData = {
        id: parentId,
        role: newValue,
      };
      dispatch(getFaq(filterData));
    } else {
      const filterData = {
        id: parentId,
        role: newValue,
      };
      dispatch(getFaq(filterData));
    }
  };

  const onDialog = (data, code) => {
    if (type?.toLowerCase() === "edit") {
      const val = {
        type: value,
        question: data?.question,
        answer: data?.answer,
        faqId: faqId,
      };
      dispatch(patchUpdateFaq(val));
    } else {
      const val = {
        type: value,
        question: data?.question,
        answer: data?.answer,
        parentId: parentId,
      };
      dispatch(postAddFaq(val));
    }

    setOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
    setDefaultValue(defaultValue);
  };
  const addFaq = () => {
    setDefaultValue({});
    setType("Create");
    setOpen(true);
  };
  const deleteFAQ = (faqId) => {
    const val = { faqId: faqId, parentId: parentId, type: value };
    dispatch(deleteFaq(val));
  };
  const editFaq = (faq) => {
    setDefaultValue(faq);
    setType("edit");
    setOpen(true);
    setFaqId(faq.id);
  };

  return (
    <div>
      <Grid container>
        <Grid
          item
          container
          justifyContent="space-between"
          alignItems="center"
          className="marginTop"
        >
          <Grid item>
            <CommonBreadCrumb paths={breadcrumbPaths} />
          </Grid>
          <Grid item>
            <Button
              onClick={() => {
                addFaq();
              }}
              className="btnSubvendor"
            >
              Add +
            </Button>
          </Grid>
        </Grid>
        <FaqTab
          editFaq={editFaq}
          deleteFaq={deleteFAQ}
          handleChange={handleTabChange}
          value={value}
          FaqData={FaqData}
          faqLoader={faqLoader}
        />
      </Grid>
      {open && (
        <CommonDialog
          open={open}
          handleClose={handleClose}
          formData={addFaqData}
          button={"dialogButton"}
          onSubmittBtn={onDialog}
          type={type === "edit" ? "Edit Question " : " Question"}
          selectType={type === "edit" ? "edit" : "Create"}
          defaultValues={defaultValue}
        />
      )}
    </div>
  );
}

export default FAQView;
